import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { elfLogger } from './elf-logger.service';

/**
 * Central route-change logger. Mirrors one-ap-customer_web's ElfRouteLoggerService
 * for React Router: emits a structured ELF log for every completed navigation,
 * recording the resolved URL. Wired up once (see <ElfRouteLogger/>) so no page
 * needs to participate.
 */
export const useElfRouteLogger = (): void => {
  const location = useLocation();

  useEffect(() => {
    try {
      const url = `${location.pathname}${location.search || ''}`;
      elfLogger.info(`Route loaded ${url}`, {
        'route.url': url,
        'log.source': 'RouteLogger'
      });
    } catch {
      // Logging must never break navigation.
    }
    // Re-run only when the resolved location changes.
  }, [location.pathname, location.search]);
};

/**
 * Renders nothing; mount once inside the Router to enable navigation logging.
 */
export const ElfRouteLogger = (): null => {
  useElfRouteLogger();
  return null;
};
